import { Program } from '../../../types/program';

export const formatInitialStepValues = (program: Program) => {
  return {
    name: program.name,
    description: program.description,
    instructorIds: program.instructors.map(instructor => instructor.id) || [],
    segmentId: program.segments,
    typeProgramId: program.typesProgram[0]?.id || 0,
  };
};
